"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function sassUrlVariantsFactory(path) {
  return function (url) {
    var extensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var parsedUrl = path.parse(url);
    var urlVariants = [url];

    if (parsedUrl.dir && !parsedUrl.ext) {
      extensions.forEach(function (extension) {
        urlVariants.push(path.join(parsedUrl.dir, "".concat(parsedUrl.name).concat(extension)));
        urlVariants.push(path.join(parsedUrl.dir, "_".concat(parsedUrl.name).concat(extension)));
      });
    }

    return urlVariants;
  };
}

exports.sassUrlVariantsFactory = sassUrlVariantsFactory;